import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { FlywheelSection } from "@/components/sections/FlywheelSection";
import { CTASection } from "@/components/sections/CTASection";
import { SEO } from "@/components/SEO";

const GrowthSystem = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Growth System | It's All About Growth"
        description="The four-pillar revenue growth system we install: GTM, acquisition, conversion, and retention — operated as one system, not isolated tactics."
        path="/growth-system"
      />
      <Header />
      <main className="pt-20">
        <FlywheelSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default GrowthSystem;
